/**
 * Wallets CRUD — Firestore + dev mode mirror.
 */
import { addDoc, collection, deleteDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, COLLECTIONS, IS_DEV_MODE } from '../../lib/firebase';
import { useWalletsStore, type Wallet } from './walletsStore';
import { generateId } from '../../lib/utils';

export interface NewWalletInput {
  familyId: string;
  ownerId: string;
  name: string;
  color: string;
  type?: 'shared' | 'personal';
}

export async function createWallet(input: NewWalletInput): Promise<string> {
  if (IS_DEV_MODE) {
    const id = generateId('wallet');
    const w: Wallet = {
      id,
      familyId: input.familyId,
      ownerId: input.ownerId,
      name: input.name,
      type: input.type ?? 'personal',
      color: input.color,
    };
    const store = useWalletsStore.getState();
    store.setWallets([...store.wallets, w]);
    return id;
  }
  const ref = await addDoc(collection(db, COLLECTIONS.wallets), {
    familyId: input.familyId,
    ownerId: input.ownerId,
    name: input.name,
    color: input.color,
    type: input.type ?? 'personal',
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

export async function updateWallet(id: string, patch: Partial<NewWalletInput>): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useWalletsStore.getState();
    store.setWallets(store.wallets.map((w) => (w.id === id ? { ...w, ...patch } : w)));
    return;
  }
  await updateDoc(doc(db, COLLECTIONS.wallets, id), patch);
}

export async function deleteWallet(id: string): Promise<void> {
  if (IS_DEV_MODE) {
    const store = useWalletsStore.getState();
    store.setWallets(store.wallets.filter((w) => w.id !== id));
    return;
  }
  await deleteDoc(doc(db, COLLECTIONS.wallets, id));
}
